module.exports = __webpack_public_path__ + "static/media/weathered-ash-grey.138ba993.jpg";